
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import HeroSection from './home/components/heroSection.vue'
import CourseType from './home/components/courseType.vue'
import RegisterGuide from './home/components/registerGuide.vue'
import ActivityGuide from './home/components/activityGuide.vue'
import CalligraphySeries from './home/components/calligraphySeries.vue'
import ChinaPaintSeries from './home/components/chinaPaintSeries.vue'
import SpecialCourse from './home/components/specialCourse.vue'
import DayCourse from './home/components/dayCourse.vue'
import SelfCourse from './home/components/selfCourse.vue'
import ShowCourse from './home/components/showCourse.vue'
import PublicCourse from './home/components/publicCourse.vue'
import HelloTong from './home/components/helloTong.vue'
import ArticleShare from './home/components/articleShare.vue'
import WenFang from './home/components/wenFang.vue'
import CompanyIntro from './home/components/companyIntro.vue'

@Component({
  components: {
    HeroSection,
    CourseType,
    ActivityGuide,
    CalligraphySeries,
    ChinaPaintSeries,
    SpecialCourse,
    DayCourse,
    SelfCourse,
    ShowCourse,
    PublicCourse,
    HelloTong,
    ArticleShare,
    WenFang,
    CompanyIntro,
    RegisterGuide
  },
  async fetch(ctx) {
    await ctx.store.$homeV2.loadJSON()
  }
})
export default class extends Vue {
  get PageStore() {
    return this.$store.$homeV2
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
